import { render, staticRenderFns } from "./MicMenu.vue?vue&type=template&id=55be81a1&scoped=true"
import script from "./MicMenu.vue?vue&type=script&lang=js"
export * from "./MicMenu.vue?vue&type=script&lang=js"
import style0 from "./MicMenu.vue?vue&type=style&index=0&id=55be81a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be81a1",
  null
  
)

export default component.exports